<script setup lang="ts">
import type { Notification, NotifyHandler, NotifyTypes } from '@/composables/notifications';
import { onMounted, ref, watch } from 'vue'
import { Sonner } from '@/components/base/sonner'
import { useNotifications } from '@/composables/notifications'
import { useResizeObserver } from '@vueuse/core'

const { processSessionNotifications, notify } = useNotifications()

defineOptions({
    compatConfig: { MODE: 3 },
})

const props = defineProps<{ legacyNotifications: Notification[] }>();
const emit = defineEmits<{ 'clear:legacyNotifications': [] }>();

const options = ref({
    offset: {
        top: 'calc(var(--kgr-pageLayout-header-height) + var(--kgr-region-padding) * 1.5)',
    },

    mobileOffset: {
        top: 'calc(var(--kgr-pageLayout-header-height) + var(--kgr-region-padding) * 1.5)',
    },

    style: {
        '--width': 'auto',
        left: 'calc(50% + var(--kgr-region-padding))',
        transform: ''
    },

    toastOptions: {
        duration: 6_000,
        style: {
            left: '50%',
            width: 'max-content',
            minWidth: '35vw',
            maxWidth: '75vw',
            transform: 'translateX(-50%) var(--y)',
        },
    },

    position: 'top-left' as const,
})

function updateOffset(el: Element) {
    if (!el) {
        return;
    }

    const rect = el.getBoundingClientRect();

    if (rect.width >= 600) {
        options.value.style['--width'] = rect.width + 'px';
        options.value.style.left = 'calc(' + (rect.left) + 'px)';
        options.value.toastOptions.style.minWidth = (rect.width / 3) + 'px';
        options.value.toastOptions.style.maxWidth = (rect.width) + 'px';
        options.value.toastOptions.style.width = 'max-content';
    } else {
        options.value.style['--width'] = rect.width + 'px';
        options.value.style.left = '0px';
        options.value.toastOptions.style.minWidth = '35vw';
        options.value.toastOptions.style.maxWidth = 'calc(100vw - var(--kgr-region-padding) * 2)';
        options.value.toastOptions.style.width = 'calc('+rect.width + 'px - var(--kgr-region-padding) * 4)';
    }
}


onMounted(() => {
    const mainEl =
        document.querySelector('.kgr-pageLayout__mainContent') ||
        document.querySelector('.kgr-pageLayout__main');

    if (mainEl) {
        useResizeObserver(mainEl as any, () => updateOffset(mainEl));
        updateOffset(mainEl);
    }

    processSessionNotifications()

    // handle legacy notifications
    watch(props.legacyNotifications, (list) => {
        list.forEach(({ message, params, settings }: Notification) => {
            const type: NotifyTypes = settings?.type || 'info';
            (notify as unknown as Record<NotifyTypes, NotifyHandler>)[type](message, params, settings);
        });

        emit('clear:legacyNotifications');
    }, { deep: true, immediate: true });
})
</script>

<template>
    <Sonner
        v-bind="options"
    />
</template>
